import { bool } from "@techstark/opencv-js";

export type IDType = {
    number: string;
    type: string;
    creationDate: string;
    status: string;
    isBlocked: boolean;
    id: number;
    nationality: string;
};

export type NotificationType = {
    to: string;
    from: string;
    action: string;
    detail: string;
    createdAt: string;
    updatedAt: string;
    isRead?: boolean;
    id: number;
    documentId: number | null;
    ownerId: number;
    seen: boolean;
};

export type DocumentUnion = FollowedDocument | LostDocument;

export type FollowedDocument = {
    createdAt: string;
    id: number;
    isBlocked?: boolean;
    isSelectedOne: boolean;
    dateExpiration?: string;
    locked?: boolean;
    lost?: boolean;
    number: string;
    prenom?: string;
    nom?: string;
    stateDoc?: string;
    status?: string;
    type: string;
    updatedAt: string;
    userId: number;
    conformite?: boolean;
    darkWeb?: boolean;

};

export type LostDocument = {
    clientNumber?: string;
    createdAt: string;
    documentIdPath?: string;
    id: number;
    prenom?: string;
    nom?: string;
    isBlocked?: boolean;
    isSelected: boolean;
    locked?: boolean;
    lost?: boolean;
    number: string;
    pvPath?: string;
    reason?: string;
    stateDoc: string;
    status?: string;
    dateExpiration?: string;
    type: string;
    typeDemande: string;
    conformite?: boolean;
    darkWeb?: boolean;
};

export type DocumentBasylic = {
    id?: number;
    number?: string;
    numeroDocument: string;
    nom: string;
    prenom: string;
    dateNaissance: string;
    paysNaissance: string;
    lieuNaissance: string;
    sexe: "M" | "F";
    typeDocument: string;
    dateExpiration: string;
    dateDelivrance: string;
    nomUsage: string;
    viz: string;
    mrz: string;
    conformite: boolean;
    darkWeb: boolean;
    locked?: boolean;
    lost?: boolean;
    country_code?: string;
};
export function isDocumentBasylic(document: any): document is DocumentBasylic {
    return (document as DocumentBasylic).nom !== undefined;
}

export type DocumentPreviewNumberType = {
    numeroDocument: string;
    typeDocument: string;
    country: string;
    status: string;
    darkWeb: boolean;
};

export type AdminUser = {
    type: "admin";
    // Autres propriétés spécifiques à l'administrateur
};

export type IndividualUser = {
    type: "individual";
    // Autres propriétés spécifiques à l'utilisateur individuel
};

export type PartnerUser = {
    type: "partner";
    // Autres propriétés spécifiques à l'utilisateur partenaire
};

export type UserType = AdminUser | IndividualUser | PartnerUser;

export type User = {
    clientNumber?: string;
    companyName?: string;
    createdAt?: string;
    credits?: number;
    email?: string;
    firstname?: string;
    id?: string;
    lastConnected?: string;
    lastname?: string;
    phoneNumber?: string;
    sizeSpace?: string;
    sizeSpaceUsed?: string;
    suspended?: boolean;
    type?: string;
    updatedAt?: string;
    picture?: any;
    mustChangeThePassword?: boolean;
    referralCode?: string;
    fromReferralCode?: string;
    mustRedirectToIDAssistant?: boolean;
    isNewUserFromWordpressAccompaniment?: boolean;
    isEnableMFA?: boolean;
  hasSeenMFAPrompt?: boolean;
  mfaType?: string;
  partnerRole?: string;
};

export type DocumentStatusType = {
    conformite?: boolean | undefined;
    lost?: boolean | undefined;
    locked?: boolean | undefined;
    darkWeb?: boolean | undefined;
    idTracker?: "requested" | "confirm" | "notRequested" | "reject";
};

export type ErrorType = {
    status: number;
    message: string;
};

export type FolderType = {
    id: number;
    name: string;
    visibility: boolean;
    system: boolean;
    adminAccess: boolean;
    typeDossier?: string;
    ownerId: number;
    createdAt: string;
    updatedAt: string;
    documents: any[];
    garants: any[];
    authorizations: Array<AuthorizationType>;
    items?: Array<ProceduresType>;
};

export type AuthorizationType = {
    client: PartnerType;
    clientId?: number;
    id: number;
    isAuthorized: boolean;
};

export type FileType = {
    id?: number;
    name: string;
    path: string;
    receivedAt?: string;
    status?: string;
    sectionsDossier?: string;
    categoriePieces?: string;
    typeGarantie?: string;
};
export type OrganismType = {
    name: string;
    logoPath: string;
};

export type ProceduresType = {
    id: number;
    title: string;
    description: string;
    checked: boolean;
    folderId: number;
    createdAt: Date;
    updatedAt: Date;
};

export type PartnerType = {
    client?: PartnerType;
    id: number;
    clientNumber: string;
    companyName: null | string;
    expirationDate: string;
    firstname: string;
    lastname: string;
    phoneNumber: string;
    authorizationId: number;
    picture?: string;
};

export type Options = {
    value: string;
    label: string;
};

export type AccompanimentType = {
    accompaniementContacts: any[];
    accompanimentClientDocuments: any[];
    documents_ids: number[];
    createdAt: string;
    id: number;
    ownerId: number;
    offreId?: number;
    status: string;
    updatedAt: string;
    dateReceptionAR: string | null | undefined;
};


export enum NOTIFICATION_ACTIONS {
    // For Tab [Pièces d'identité] in the web app
    Document_View_Request = 'document_view_request',
    Document_View_Request_New_Status = 'document_view_request_new_status',
    Document_Lost_Declaration = 'document_lost_declaration',
    Document_Delete = 'document_delete',
    Folder_Notification = 'folder_notification',
    Document_Delete_Followed = 'document_delete_followed',
    Document_New_Followed = 'document_new_followed',
    Document_Change_Followed_State = 'document_change_followed_state',

    // For Tab [ID Locker] in the web app
    Folder_Creation = 'folder_creation',
    Folder_Delete = 'folder_delete',
    File_Added = 'file_added',
    File_Delete = 'file_delete',
    Invitation_Send = 'invitation_send',
    Permission_Deleted = 'permission_deleted',
    Permission_Changed = 'permission_changed',
    Visibility_Changed = 'visibility_changed',
    Expired_Date_Changed = 'expired_date_changed',

    // For Tab [ID Assistant] in the web app
    Accompaniment_New_Status = 'accompaniment_new_status',
    Accompaniment_New = 'accompaniment_new',
    Accompaniment_Delete = 'accompaniment_delete',
}

export enum NotificationLabelTab {
    PIECE_ID = "Pièces d'identité",
    ID_ASSISTANT = "ID Assistant",
    ID_LOCKER = "ID Locker",
    TOUS = "Tous",
}
export enum TrustfullLabelTab {
    COHERENTS = "Indices de fiabilité",
    INCOHERENTS = "Indices de risque",
    TOUS = "Tous",
}

export type TrustfullResponse = {
  resolution_id: string;
  customer_id: string;
  device_request_time: string;
  phone: {
    value: string;
    type: string;
    status: string;
    is_disposable: boolean;
    is_valid: boolean;
    is_suspicious_format: boolean;
    is_valid_format: boolean;
    country_code: string;
    is_ported: boolean;
    original_network: string;
    current_network: string;
    original_mno_code: string;
    current_mno_code: string;
    has_whatsapp: boolean;
    whatsapp_privacy_status: string;
    whatsapp_image: string;
    score: number;
    score_cluster: string;
    number_type: string;
    has_telegram: boolean;
    has_instagram: boolean;
    has_amazon: boolean;
    has_office365: boolean;
    first_name: string;
    last_name: string;
    image_source: string;
    image_labels: string;
    face1_labels: string;
    face1_bounding_box: string;
    face1_age_range: string;
    face1_is_celebrity: boolean;
    has_facebook: boolean;
    data_breaches_count: number;
    data_breaches_first_breach: string;
    data_breaches_last_breach: string;
    data_breaches_list: string;
    data_breaches_data: string;
    data_breaches_data_lists: string;
    has_twitter: boolean;
    has_skype: boolean;
    phone_partials_count: number;
    email_partials_count: number;
    email_partials_list: string;
    reason_codes: string;
    has_apple: boolean;
    is_whatsapp_business: boolean;
    identity_email_count: number;
    identity_ip_count: number;
    identity_name_count: number;
    has_weibo: boolean;
    first_seen: string;
    to_name: string;
  };
  email: {
    value: string;
    status: string;
    is_disposable: boolean;
    is_role: boolean;
    is_spamtrap: boolean;
    is_free: boolean;
    domain: string;
    domain_age: number;
    domain_mx_is_valid: boolean;
    domain_mx_provider: string;
    domain_registrar: string;
    domain_registered_to: string;
    has_twitter: boolean;
    has_amazon: boolean;
    has_linkedin: boolean;
    has_spotify: boolean;
    has_deliveroo: boolean;
    has_pinterest: boolean;
    has_office365: boolean;
    has_hubspot: boolean;
    has_wordpress: boolean;
    has_instagram: boolean;
    first_name: string;
    last_name: string;
    avatar: string;
    employment: string;
    domain_website_exists: boolean;
    domain_website_exists_taxonomy: string;
    domain_website_exists_ssl: boolean;
    account_length: number;
    account_dots_count: number;
    account_numbers_count: number;
    account_letters_count: number;
    account_symbols_count: number;
    account_vowels_count: number;
    account_consonants_count: number;
    account_dots_ratio: number;
    account_numbers_ratio: number;
    account_letters_ratio: number;
    account_symbols_ratio: number;
    account_vowels_ratio: number;
    account_consonants_ratio: number;
    contains_first_name: boolean;
    contains_last_name: boolean;
    has_stop_words: boolean;
    has_facebook: boolean;
    has_apple: boolean;
    has_paypal: boolean;
    has_disney_plus: boolean;
    has_google: boolean;
    google_id: string;
    google_last_edit: string;
    google_active_services_count: number;
    google_active_services_list: string;
    google_review_link: string;
    data_breaches_count: number;
    linkedin_profile_page: string;
    has_skype: boolean;
    has_gravatar: boolean;
    phone_partials_count: number;
    phone_partials_list: string;
    email_partials_count: number;
    score: number;
    score_cluster: string;
    image_source: string;
    image_labels: string;
    face1_labels: string;
    face1_bounding_box: string;
    face1_age_range: string;
    face1_is_celebrity: boolean;
    reason_codes: string;
    has_duolingo: boolean;
    identity_ip_count: number;
    identity_msisdn_count: number;
    identity_name_count: number;
    has_atlassian: boolean;
    has_lastpass: boolean;
    has_adobe: boolean;
    has_freelancer: boolean;
    has_github: boolean;
    first_seen: string;
    domain_internal_links_count: number;
    domain_external_links_count: number;
    domain_internal_email_links_count: number;
    domain_external_email_links_count: number;
    domain_internal_images_count: number;
    domain_external_images_count: number;
    domain_page_size: number;
    to_name: string;
  };
  name: {
    value: string;
    is_valid: boolean;
    gender: string;
    score: number;
    score_cluster: string;
    identity_email_count: number;
    identity_msisdn_count: number;
    identity_ip_count: number;
  };
  score: {
    score: number;
    score_cluster: string;
    reason_codes: string;
  };
  goodDescriptions: {
    code: string;
    name: string;
    description: string;
  }[];
  badDescriptions: {
    code: string;
    name: string;
    description: string;
  }[];
  dataBaseResult?: {
    founded: boolean,
    where: string | null | undefined,
    cardNumber: string | null | undefined
  }
};


// Pour le parcours de création d'un dossier ID Locker

export type Visibilité = "public" | "secret"; // Pour le bouton "Rendre secret"

export enum Type_dossier { // Types de dossier à protéger
    LOCATION_LOGEMENT = "Location de logement",
    // VEHICULE_OCCASION = "Véhicule d'occasion",
    AUTRE = "Autre",
};

export enum Sections_dossier {
    LOCATAIRE = "Documents du Locataire", // Section locataire
    GARANTS = "Garant(s)", // Section garants
}

export enum Categorie_pieces { // Documents constitutifs du dossier
    IDENTITE = "Justificatif d'identite",
    DOMICILE = "Justificatif de domicile",
    SITUATION_PRO = "Justificatif de situation professionnelle",
    RESSOURCES = "Justificatif de ressources",
};
export enum Categorie_pieces_2 { // Documents constitutifs du dossier
    CERTIFICAT_GARANTIE = "Certificat de garantie",
};

export type Item_Doc = { // Fichier téléversé 
    id: string;
    name: string;
}

export enum Type_garantie { // Types de garants
    PHYSIQUE = "Garant Physique",
    INSTITUTIONNEL = "Garant institutionnel (Visale, etc)",
    BANQUE = "Banque",
}

export type Base_Garant = { // Tronc commun d'un garant
    id: string;
    name:string;
    type: Type_garantie;
    depliee: boolean;
}

//Garant physique : memes rubriques que le locataire 
export type GarantPhysique = Base_Garant & {
    type: Type_garantie.PHYSIQUE;
    docs: Section_Locataire;
}

//Garant mono-bloc : certificat unique (Institutionnel ou banque)
export type GarantMonoBloc = Base_Garant & {
    type: Type_garantie.INSTITUTIONNEL | Type_garantie.BANQUE;
    certificate : Item_Doc[];
}

export type Garant = GarantPhysique | GarantMonoBloc; // Union de tous les garants possibles

export type Section_Locataire = Record<Categorie_pieces, Item_Doc[]>; // Ensemble des docs locataire

export type Statut_Section = "COMPLET" | "INCOMPLET"; // Pour savoir si une section est complète

export type Dossier = FolderType & { // Structure d'un dossier complet
    title?: string;
    type?: Type_dossier;
    secret?: boolean;
    locataire?: Section_Locataire;
    garants?: Garant[];
};

export interface DocumentType {
    id: number;
    name: string;
    category: Categorie_pieces;
    url: string;
    type: string; 
    size: number; 
    uploadedAt: string; // Date au format ISO string, e.g., "2023-10-27T10:00:00Z"
}

export type AppState = { dossiers: Dossier[]; ui: { route: "grid" | { dossierId: number; left: Sections_dossier, garantDetail?: string; }; showCreate: boolean } };


export interface DocumentStats {
  lost: ApiResultItem[]
  followed: ApiResultItem[]
  darkWeb: ApiResultItem[]
  notFound: ApiResultItem[]
}
// ---- Types ----
interface ApiResultItem {
  docNumber: string
  requestDate: string
}

export type FraudEntryType = "url" | "image" | null;


export type FraudResponse = {
  data: {
    titre?: string;
    prix?: number;
    surface?: number;
    pieces?: number;
    localisation?: string;
    description?: string;
    photos?: string[];
    type_logement?: string;
    is_pro?: boolean | null;
  };
  analysis: {
    score: number;
    status: "OK" | "A_VERIFIER" | "SUSPECT";
    suspicions: string[];
    insights?: string[];
  };
  market?: {
    city?: string | null;
    postal?: string | null;
    eur_m2?: number | null;
    band_min?: number | null;
    band_max?: number | null;
    sample_size?: number | null;
  };
  meta?: {
    owner_ads_count?: number | null;
    phone_verified?: boolean | null;
    is_reactive?: boolean | null;
    last_activity?: string | null;
    member_since_raw?: string | null;
    is_pro?: boolean | null;
  };
  url: string;
};

